import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'
import ReactDOM from 'react-dom'
import './Toast.scss'

const ToastContext = createContext()

export const useToast = () => {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within ToastProvider')
  }
  return context
}

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([])

  const addToast = useCallback(
    ({ title, description, status = 'info', duration = 4000 }) => {
      const id = Date.now() + Math.random()
      setToasts(prev => [...prev, { id, title, description, status, duration }])
    },
    []
  )

  const removeToast = useCallback(id => {
    setToasts(prev => prev.filter(t => t.id !== id))
  }, [])

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      {ReactDOM.createPortal(
        <div className="tb-toast-container">
          {toasts.map(toast => (
            <ToastItem
              key={toast.id}
              {...toast}
              onClose={() => removeToast(toast.id)}
            />
          ))}
        </div>,
        document.body
      )}
    </ToastContext.Provider>
  )
}

const ToastItem = ({ id, title, description, status, duration, onClose }) => {
  const [isExiting, setIsExiting] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExiting(true)
      setTimeout(onClose, 300)
    }, duration)
    return () => clearTimeout(timer)
  }, [duration, onClose])

  const icons = {
    success: '✅',
    error: '❌',
    warning: '⚠️',
    info: 'ℹ️',
  }

  return (
    <div
      className={`tb-toast tb-toast--${status} ${isExiting ? 'tb-toast--exit' : ''}`}
    >
      <span className="tb-toast__icon">{icons[status]}</span>
      <div className="tb-toast__content">
        <p className="tb-toast__title">{title}</p>
        {description && <p className="tb-toast__desc">{description}</p>}
      </div>
      <button
        className="tb-toast__close"
        onClick={() => {
          setIsExiting(true)
          setTimeout(onClose, 300)
        }}
      >
        ×
      </button>
    </div>
  )
}
